export default function () {
  return {
    allProjects: [],
    workload: [],
    filterDays: null,
    filterUser: null,
    currentTabKey: 'list',
  }
}
